export const isVcht = ['afisha.dop.edu.ru'].includes(window.location.hostname)
  || window.localStorage.getItem('active_api') === 'https://api.dop.edu.ru/v1';

export const isVrn = ['pfdo-events.govvrn.ru'].includes(window.location.hostname)
  || window.localStorage.getItem('active_api') === 'https://pfdo-eventsapi.govvrn.ru/v1';

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i
  .test(navigator.userAgent);

export const isProductionMode = process.env.VUE_APP_MODE_NAME === 'production';

export const isDevelopmentMode = process.env.VUE_APP_MODE_NAME === 'development';

export const isVchtMode = process.env.VUE_APP_MODE_NAME === 'vcht';
